module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("hb2yi"))).then(() => parcelRequire('f0IuU'));